import {Component, Input} from '@angular/core';
import {RuleViewModel} from '../../models/rule-view-model.interface';
import {IconComponent} from '../../../../shared/icons/icon.component';
import {RouterLink} from '@angular/router';
import {RouteConstants} from '../../../../shared/constants/route-constants';
import {RuleNamePipe} from '../../pipes/rule-name.pipe';

@Component({
  selector: 'app-rule-list-item',
  imports: [
    IconComponent,
    RouterLink,
    RuleNamePipe
  ],
  templateUrl: './rule-list-item.component.html',
  styleUrl: './rule-list-item.component.scss'
})
export class RuleListItemComponent {
  @Input() rule?: RuleViewModel
  protected readonly RouteConstants = RouteConstants;

  get description(): string | null {
    return this.rule?.actions?.map(a => a.device?.name || a.deviceGroup?.name).join(',') ?? null;
  }
}
